import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const fetchAdminData = () => {
  return Api(endPoints.adminData, {}, requestType.GET);
};

const getSettings = () => {
  return Api(endPoints.getSettings, null, requestType.GET);
};
const updateSettings = (id, params) => {
  return Api(`${endPoints.updateSettings}/${id}`, params, requestType.POST);
};
export { fetchAdminData, getSettings, updateSettings };
